import { Status as AssignmentStatus } from 'api/assignments/types';

export { AssignmentStatus };

// The detail view keeps its existing empty state separate from the API response.
export const emptyAssignmentData = {
    uuid: null,
    year: null,
    week: null,
    status: null,
    customer: null,
    country: null,
    county: null,
    financials: null,
    report: null,
    reportTemplate: null,
    allowTravelsheet: false,
    bookingConfirmation: null,
};

export const AssignmentStatuses: AssignmentStatus[] = Object.values(
    AssignmentStatus
).filter((status): status is AssignmentStatus => typeof status === 'string');

export const StatusToString = (status: AssignmentStatus): string => {
    switch (status) {
        case AssignmentStatus.REQUESTED:
            return 'Förfrågan';
        case AssignmentStatus.AVAILABLE:
            return 'Önskemål';
        case AssignmentStatus.BOOKED:
            return 'Bekräftat';
        case AssignmentStatus.TIME_REPORTED:
            return 'Tidrapporterat';
        case AssignmentStatus.ATTESTED:
            return 'Attesterat';
        case AssignmentStatus.DONE:
            return 'Avslutat';
        case AssignmentStatus.CANCELLED:
            return 'Avbokat';
    }
};

const StatusToOrder = (status: AssignmentStatus): number => {
    switch (status) {
        case AssignmentStatus.REQUESTED:
            return 1;
        case AssignmentStatus.AVAILABLE:
            return 2;
        case AssignmentStatus.BOOKED:
            return 3;
        case AssignmentStatus.TIME_REPORTED:
            return 4;
        case AssignmentStatus.ATTESTED:
            return 5;
        case AssignmentStatus.DONE:
            return 6;
        case AssignmentStatus.CANCELLED:
            return 7;
        default:
            return -1; // Invalid status
    }
};

export const StatusLowerThan = (
    status: AssignmentStatus,
    target: AssignmentStatus
): boolean => {
    return StatusToOrder(status) < StatusToOrder(target);
};

export const StatusHigherThan = (
    status: AssignmentStatus,
    target: AssignmentStatus
): boolean => {
    return StatusToOrder(status) > StatusToOrder(target);
};
